import React, { Component } from 'react';

class CustomDivider extends Component {
  render() {
    return <div className={'w-full border-[.5px] border-[#E0E4E8] bg-white flex '}></div>;
  }
}

export default CustomDivider;
